export const TEMPLATE_TYPES = {
  SEVERITY: "SEVERITY" as const,
  RISK_RATING: "RISK_RATING" as const,
};

export const SLA_PHASES = {
  TRIAGE: "TRIAGE" as const,
  REMEDIATION: "REMEDIATION" as const,
  RESOLUTION: "RESOLUTION" as const,
};

export const SLA_START_OPTIONS = {
  FOUND_ON_DATE: "FOUND_ON_DATE" as const,
  FINDING_INGESTION_DATE: "FINDING_INGESTION_DATE" as const,
  CONFIRMED_TRANSITION_DATE: "CONFIRMED_TRANSITION_DATE" as const,
  TICKET_CREATION_DATE: "TICKET_CREATION_DATE" as const,
  FINDING_TAG: "FINDING_TAG" as const,
};

export const SLA_START_OPTION_LABELS = {
  FOUND_ON_DATE: "Found On",
  FINDING_INGESTION_DATE: "ArmorCode Ingestion Date",
  CONFIRMED_TRANSITION_DATE: "Confirmed Transition Date",
  TICKET_CREATION_DATE: "Ticket Creation Date",
  FINDING_TAG: "Finding Tags",
};

export const SEVERITY_LEVELS = ["CRITICAL", "HIGH", "MEDIUM", "LOW"] as const;

export const RISK_RATING_LEVELS = [
  "veryPoorRiskScore",
  "poorRiskScore",
  "fairRiskScore",
  "goodRiskScore",
] as const;

export const DEFAULT_DURATION = null;

export const MAX_NAME_LENGTH = 100;
export const MAX_DESCRIPTION_LENGTH = 500;

export const RECALCULATION_SCENARIOS = [
  "SEVERITY_CHANGE",
  "GROUP_CHANGE",
  "REOPEN_RESOLUTION_TO_TRIAGE",
  "REOPEN_RESOLUTION_TO_REMEDIATION",
  "REMEDIATION_TO_TRIAGE",
];

export const TRIAGE_DROPDOWN_OPTIONS = [
  {
    label: SLA_START_OPTION_LABELS.FOUND_ON_DATE,
    value: SLA_START_OPTIONS.FOUND_ON_DATE,
  },
  {
    label: SLA_START_OPTION_LABELS.FINDING_INGESTION_DATE,
    value: SLA_START_OPTIONS.FINDING_INGESTION_DATE,
  },
  {
    label: SLA_START_OPTION_LABELS.TICKET_CREATION_DATE,
    value: SLA_START_OPTIONS.TICKET_CREATION_DATE,
  },
  {
    label: SLA_START_OPTION_LABELS.FINDING_TAG,
    value: SLA_START_OPTIONS.FINDING_TAG,
  },
];

export const HOUR = 60 * 60 * 1000;
